/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import useUtils from './useUtils'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import Pagination from '../../modules/pagination/Pagination'

const AnnouncementT = ({className}) => {
  const {fetchAnnouncementT, deleteAnnouncementT, onEdit} = useUtils()
  const [announcementT, setAnnouncementT] = useState()
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Announcement'))

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)

  const getAnnouncementT = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchAnnouncementT(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setAnnouncementT(result)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteAnnouncementT(selectedId, limit, (page - 1) * limit)
      setAnnouncementT(result)
    } catch (error) {
      console.error('Error deleting Announcement type:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  useEffect(() => {
    getAnnouncementT()
  }, [limit, page])

  const handleEdit = async (id) => {
    const values = await onEdit(id )
    navigate('/announcement-types/editannouncementtype', {state: {values}})
  }

  if (loading) return <TableSkeleton />
  return (
    <>
      <div className={`card ${className}`}>
        <div className='d-flex card-header border-0 pt-5'>
          <div className='d-flex align-items-center flex-wrap gap-10'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='mt-1 text-muted fs-7 '>{announcementT?.count} Items</span>
            </h3>
            {/* begin::Search */}
          </div>
          <div className='card-toolbar'>
            <a
              onClick={() => navigate('/announcement-types/addannouncementtype')}
              className='btn btn-sm btn-light-primary'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Add Announcement Type
            </a>
          </div>
        </div>
        <div className='card-body py-10'>
          <div className='table-responsive row justify-content-center'>
            <div className='col-lg-12'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 '>
                <thead className='align-top'>
                  <tr className='fw-bold text-muted'>
                    <th className='w-200px'>NAME</th>
                    <th className='w-100px'>ICON</th>

                    <th className='min-w-100px text-end'>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {announcementT?.records &&
                    announcementT?.records?.map((value, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <a href='#' className='text-dark fw-bold  fs-6'>
                              {value.type}
                            </a>
                          </td>

                          <td>
                            <a href='#' className='text-dark fw-bold  fs-6'>
                              <img style={{height: '24px', width: '24px'}} src={value.imageUrl} />
                            </a>
                          </td>
                          <td className='text-end'>
                            <a
                              onClick={() => handleEdit(value.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-3 svg-icon-primary'
                              />
                            </a>
                            <a
                              onClick={() => handleDelete(value.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3 text-danger'
                              />
                            </a>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <DeleteConfirmation
            isVisible={modalVisible}
            message='Are you sure you want to delete announcement type?'
            onConfirm={confirmDelete}
            onCancel={() => setModalVisible(false)}
          />
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
    </>
  )
}

export default AnnouncementT
